import axios from "axios";

const url = process.env.REACT_APP__BASE_URL;

const Auth = {
  loginHandler: (payload) => {
    const response = axios({
      url: `${url}/app/auth/login`,
      method: "POST",
      data: JSON.stringify({
        email: payload.email,
        password: payload.password,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  registerUserHandler: (payload) => {
    const response = axios({
      url: `${url}/app/auth/register`,
      method: "POST",
      data: JSON.stringify({
        fullname: payload.fullname,
        email: payload.email,
        password: payload.password,
        phone_no: payload.phone_no,
        business_name: payload.business_name,
        account_type: "DISTRIBUTOR",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  requestPasswordReset: (payload) => {
    const response = axios({
      url: `${url}/app/auth/passwords/request`,
      method: "POST",
      data: JSON.stringify({
        email: payload.email,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  resertPassword: (payload) => {
    const response = axios({
      url: `${url}/app/auth/passwords/reset`,
      method: "POST",
      data: JSON.stringify({
        email: payload.email,
        password: payload.password,
        token: payload.token,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  updateUserHandler: (payload) => {
    const response = axios({
      url: `${url}/app/admin/customer/update/${payload.plateNumber}`,
      method: "POST",
      data: JSON.stringify({
        fullname: payload.fullname,
        email: payload.email,
        phone_no: payload.phone_no,
        date_of_birth: payload.date_of_birth,
        gender: payload.gender,
        occupation: payload.occupation,
        address: payload.address,
        chassis: payload.chassis,
        engine_number: payload.engine_number,
        make: payload.make,
        model: payload.model,
        year: payload.year,
        issue_date: payload.issue_date,
        expiry_date: payload.expiry_date,
        vl_issue_date: payload.vl_issue_date,
        vl_expiry_date: payload.vl_expiry_date,
        road_expiry_date: payload.road_expiry_date,
        road_message: payload.road_message,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  registerFixedAgentHandler: (payload) => {
    const response = axios({
      url: `${url}/app/auth/fixedagent/register`,
      method: "POST",
      data: JSON.stringify({
        fullname: payload.fullname,
        email: payload.email,
        password: payload.password,
        phone_no: payload.phone_no,
        business_name: payload.business_name,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  registerVerifierHandler: (payload) => {
    const response = axios({
      url: `${url}/app/auth/register`,
      method: "POST",
      data: JSON.stringify({
        fullname: payload.fullname,
        email: payload.email,
        password: payload.password,
        phone_no: payload.phone_no,
        account_type: "VERIFIER",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  logoutHandler: (payload) => {
    const response = axios({
      url: `${url}/app/auth/logout`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  updateProfileHandler: (payload) => {
    const response = axios({
      url: `${url}/app/auth/user/update`,
      method: "POST",
      data: JSON.stringify({
        fullname: payload.fullname,
        phone_no: payload.phone_no,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getUserInfo: (payload) => {
    const response = axios({
      url: `${url}/app/auth/user`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getUserWalletInfo: (payload) => {
    const response = axios({
      url: `${url}/app/auth/user/wallet`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getAgentBirthday: () => {
    // Airtable request paused by request.
    // return axios({
    //   url: "{airtableAgentBirthdaysEndpoint}",
    //   method: "GET",
    //   headers: { Authorization: "Bearer {airtableToken}" },
    // });
    return Promise.resolve({ data: { records: [] } });
  },

  createAgentBirthday: () => {
    // Airtable request paused by request.
    // return axios({
    //   url: "{airtableAgentBirthdaysEndpoint}",
    //   method: "POST",
    //   data: { records: [{ fields: { name, email, DOB } }] },
    //   headers: { Authorization: "Bearer {airtableToken}" },
    // });
    return Promise.resolve({ data: { records: [] } });
  },
};

export default Auth;
